import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { FormGroup, Input, Label } from 'reactstrap';
import { AppSearchField, AppDateRange } from '@common';

import '../style.scss';

const SubFilters = (props) => {
  console.log(props, 'what i all have');
  const [filteredOptions, setFilteredOptions] = React.useState(props.item.list);

  useEffect(() => {
    setFilteredOptions(props.item.list);
  }, [props.item.list]);

  useEffect(() => {
    return () => {
      searchCall.cancel(); // Clean up debounce on unmount
    };
  }, []);

  const dropDownClasses = `dashboardFilters--dropdown--submenu ${
    props.dropdown ? 'show' : ''
  } ${props.openLeft ? 'left-align' : ''}
  ${props.item.type === 'range' ? 'range' : ''}`;

  const searchCall = debounce((e) => {
    const lowerSearchTerm = e.toLowerCase();
    const filteredObj = Object.fromEntries(
      Object.entries(props.item.list).filter(([key, value]) => {
        // we are using keyafterremoving hidden character because in sub sub filters we add a hidden
        // character by which we can split and send the sub sub team to api request
        // we are removing it here to get clear search as it cause issue here

        let keyafterRemovingHiddenCharacter = key.replace(/\u200B./g, '');
        return keyafterRemovingHiddenCharacter
          .toLowerCase()
          .includes(lowerSearchTerm);
      })
    );
    setFilteredOptions(filteredObj);
  }, 1000);

  function allCheckedHandler(obj1, obj2) {
    // Compare number of keys
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    if (obj1Keys.length !== obj2Keys.length) {
      return false;
    }

    // Compare keys and values
    for (let key of obj1Keys) {
      if (obj2.hasOwnProperty(key)) {
        // Check if values are objects themselves and need deep comparison
        if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
          if (!allCheckedHandler(obj1[key], obj2[key])) {
            return false; // If any nested object fails
          }
        } else if (obj1[key] !== obj2[key]) {
          return false; // If primitive values differ
        }
      } else {
        return false; // Key mismatch
      }
    }

    return true;
  }

  return (
    <div className={`${dropDownClasses}`}>
      {props.item.title !== 'Date' && (
        <>
          <div className="dashboardFilters--dropdown--menu-header">
            <span className="dashboardFilters--dropdown--menu-header--text">
              {props.item.title}
            </span>
          </div>
          <div className="dashboardFilters--dropdown--search-field">
            <AppSearchField handleSearchCallBack={searchCall} />
          </div>
        </>
      )}
      <ul>
        {props.item.title !== 'Date' ? (
          <>
            <li className="dashboardFilters--dropdown--item">
              <FormGroup
                noMargin={true}
                check
                className="form-group custom-checkbox"
              >
                <Input
                  type="checkbox"
                  onChange={() => {
                    if (
                      Object.entries(filteredOptions).length ===
                      Object.entries(props.item.list).length
                    ) {
                      props.dispatch({ type: 'SELECT_ALL_TOGGLE' });
                    } else {
                      props.dispatch({
                        type: 'ADD_FILTERED_OPTIONS',
                        value: filteredOptions,
                      });
                    }
                  }}
                  checked={allCheckedHandler(
                    filteredOptions,
                    props.item.selectedList
                  )}
                />
                <Label check>Select All</Label>
              </FormGroup>
            </li>

            {Object.entries(filteredOptions).length > 0
              ? Object.entries(filteredOptions).map((item, index) => {
                  const handleClick = () => {
                    props.dispatch({
                      type: 'TOGGLE_CARD',
                      value: item[0],
                      id: item[1],
                    });
                  };
                  return (
                    <li
                      key={crypto.randomUUID()}
                      className="dashboardFilters--dropdown--item"
                    >
                      <FormGroup
                        noMargin={true}
                        check
                        className="form-group custom-checkbox "
                      >
                        <Input
                          type="checkbox"
                          id={crypto.randomUUID()}
                          key={crypto.randomUUID()}
                          onChange={handleClick}
                          checked={
                            props.item.selectedList[item[0]] ? true : false
                          }
                        />
                        <Label htmlFor={index} check key={crypto.randomUUID()}>
                          {item[0]}
                        </Label>
                      </FormGroup>
                    </li>
                  );
                })
              : null}
          </>
        ) : (
          <li>
            <AppDateRange onSubmit={props.handleDateSelection} />
          </li>
        )}
      </ul>
    </div>
  );
};

export default SubFilters;
